import { render, staticRenderFns } from "./ModerationStatus.vue?vue&type=template&id=108b5044&scoped=true"
import script from "./ModerationStatus.vue?vue&type=script&lang=js"
export * from "./ModerationStatus.vue?vue&type=script&lang=js"
import style0 from "./ModerationStatus.vue?vue&type=style&index=0&id=108b5044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b5044",
  null
  
)

export default component.exports